import { ABROAD_BIRTH_PLACE_ID } from "../../../../constants";

const toposEggrafisDimotologiouValidate = (value, ctx) => {
  if (
    value ||
    parseInt(ctx?.parent?.place_birth_afora?.id) !== ABROAD_BIRTH_PLACE_ID
  ) {
    return true;
  } else {
    return false;
  }
};

export default toposEggrafisDimotologiouValidate;
